import { Link } from 'react-router-dom';
import { categories } from '@/lib/content';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-950">
                5
              </span>
              <span className="font-heading text-lg font-bold text-background-50">5看料网</span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-background-300">
              把冗长的热点压缩成速览要点与精简摘要，让你用碎片时间快速掌握核心信息。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200">
                <i className="ri-mail-line text-base" aria-hidden="true"></i>
              </span>
              <span className="font-body text-sm text-background-200">hello@5kanliao.com</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              <Link to="/hot">内容导航</Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/" className="font-body text-sm text-background-300 transition-colors hover:text-accent-300">
                  首页速览
                </Link>
              </li>
              <li>
                <Link to="/hot" className="font-body text-sm text-background-300 transition-colors hover:text-accent-300">
                  热门速览列表
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-body text-sm text-background-300 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="font-body text-sm text-background-300 transition-colors hover:text-accent-300">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              <Link to="/#categories">主题分类</Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 5).map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/hot?category=${category.key}`}
                    className="font-body text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">速览约定</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li className="font-body text-sm leading-relaxed text-background-300">
                所有内容均以公开信息为基础整理
              </li>
              <li className="font-body text-sm leading-relaxed text-background-300">
                摘要仅代表信息概览，不构成任何结论
              </li>
              <li className="font-body text-sm leading-relaxed text-background-300">
                如涉及内容异议，可通过联系页面反馈
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-primary-900 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs text-background-300">
            © {year} 5看料网 · 速览快看，碎片精简摘要概览
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/about" className="whitespace-nowrap font-body text-xs text-background-300 transition-colors hover:text-accent-300">
              内容原则
            </Link>
            <Link to="/contact" className="whitespace-nowrap font-body text-xs text-background-300 transition-colors hover:text-accent-300">
              意见反馈
            </Link>
            <a href="#top" className="whitespace-nowrap font-body text-xs text-background-300 transition-colors hover:text-accent-300">
              返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}